module.exports = __webpack_public_path__ + "mainassets/img/graf1.a6930317.svg";